import { render, staticRenderFns } from "./park.vue?vue&type=template&id=2fa5f9d9&scoped=true&"
import script from "./park.vue?vue&type=script&lang=js&"
export * from "./park.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa5f9d9",
  null
  
)

export default component.exports